import { createContext } from 'react'
import type { ConfirmationModalContextType } from '../shared'

export const ConfirmationModalContext =
    createContext<ConfirmationModalContextType>({
        showConfirmationModal: () => {},
        closeConfirmationModal: () => {},
        isConfirmationModalOpen: false,
    })
